import { render, staticRenderFns } from "./EditSalesContact.vue?vue&type=template&id=b30adbd8&"
import script from "./EditSalesContact.vue?vue&type=script&lang=js&"
export * from "./EditSalesContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports